export default "__VITE_ASSET__DZDPse3g__"